// extracted by mini-css-extract-plugin
export default {"heading":"bu-z","corrected":"cu-z","redirectVerbiageContainer":"du-z","redirectVerbiageText":"eu-z"};